import { Component, OnInit } from '@angular/core';
import { Localiser } from '../../services/localiser';
import { Navigation } from '../../services/navigation.service';
import {WebSocketService} from "../../services/web-socket.service";
import {ProyectoService} from "../../services/proyecto.service";
import {Roles} from '../../commons/util';
import {UserService} from '../../services/user.service';

@Component({
  selector: 'app-home-ateneo',
  templateUrl: './home-ateneo.component.html',
  styleUrls: ['./home-ateneo.component.css']
})
export class HomeAteneoComponent implements OnInit {

  constructor(public localiser: Localiser, private navigation: Navigation, private proyectoService: ProyectoService,
              private webSocketService: WebSocketService,
              public user: UserService) { }

  ngOnInit(): void {
  }

  toLocations() {
    this.proyectoService.setLastPage("");
    this.navigation.toLocations();
  }

  toIndicators() {
    this.navigation.toIndicators();
  }

  toDevices() {
    this.navigation.toDevices();
  }

  toAirfal() {
    this.navigation.toAirfal();
  }

  toAutotest() {
    this.navigation.toAutotest();
  }

  toFloorplans() {
    this.navigation.toSelectFloorplan();
  }

  toAteneoZones() {
    this.navigation.toAteneoZones();
  }

  toReports() {
    this.navigation.toReports();
  }

  toAlerts() {
    this.navigation.toAlerts();
  }

  toReglas() {
    this.navigation.toReglas();
  }

  toFade() {
    this.navigation.toFade();
  }

  toLimits() {
    this.navigation.toLimits();
  }

  toUsers() {
    this.navigation.toUsers();
  }

  toOta() {
    this.navigation.toOta();
  }

  toParameters() {
    this.navigation.toParameters();
  }

  public readonly Roles = Roles;
}
